import FiSearch from '@meronex/icons/fi/FiSearch';
import icon from './StyledIcon';
export default icon(FiSearch);
